var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "container1",
    },
    [
      _c("header", { staticClass: "header" }, [
        _c(
          "div",
          {
            staticClass: "back",
            on: {
              click: function ($event) {
                return _vm.$router.back()
              },
            },
          },
          [
            _c("img", {
              attrs: { src: require("images/back.png"), width: "10" },
            }),
            _c("span", [_vm._v("返回")]),
          ]
        ),
        _c(
          "div",
          [
            _c(
              "el-button",
              {
                staticStyle: {
                  "padding-left": "25px",
                  "padding-right": "25px",
                },
                attrs: { type: "primary", size: "small" },
                on: { click: _vm._parsingHtml },
              },
              [_vm._v("保存")]
            ),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "main" }, [
        _vm._m(0),
        _c("div", { staticClass: "origin-area" }, [
          _c("div", { staticClass: "title" }, [_vm._v("点击查看原题")]),
          _c(
            "div",
            { staticClass: "questionIndexContainer" },
            [
              _vm._l(_vm.questionList, function (q, i) {
                return _c(
                  "div",
                  { key: i, staticClass: "indexItem-container" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "indexItem",
                        class: { active: q.count > 0 },
                        on: {
                          click: function ($event) {
                            return _vm.handleQuestionClick(q, i)
                          },
                        },
                      },
                      [_vm._v(_vm._s(q.num))]
                    ),
                  ]
                )
              }),
              _c("div", {
                staticClass: "indexItem-container",
                staticStyle: { height: "0", "margin-bottom": "0" },
              }),
              _c("div", {
                staticClass: "indexItem-container",
                staticStyle: { height: "0", "margin-bottom": "0" },
              }),
              _c("div", {
                staticClass: "indexItem-container",
                staticStyle: { height: "0", "margin-bottom": "0" },
              }),
              _c("div", {
                staticClass: "indexItem-container",
                staticStyle: { height: "0", "margin-bottom": "0" },
              }),
            ],
            2
          ),
        ]),
      ]),
      _c(
        "yue-dialog",
        {
          attrs: {
            title: "查看原题",
            visible: _vm.dialogFormVisible,
            width: "800px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "origin-question" }, [
            _c(
              "div",
              {
                staticClass: "content",
                staticStyle: { "line-height": "20px" },
              },
              [
                _vm.examInfo.hasPaper == 2
                  ? _c("div", [
                      _c("div", {
                        domProps: {
                          innerHTML: _vm._s(_vm.currentQuestion.info.content),
                        },
                      }),
                      _vm.currentQuestion.options
                        ? _c(
                            "div",
                            { staticClass: "options" },
                            _vm._l(
                              _vm.currentQuestion.options,
                              function (opt, index) {
                                return _c("span", {
                                  staticClass: "options-item",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.optionLabels[index] +
                                        ". " +
                                        opt.content
                                    ),
                                  },
                                })
                              }
                            ),
                            0
                          )
                        : _vm._e(),
                    ])
                  : _c("div", { staticClass: "no-content" }, [
                      _c("img", {
                        attrs: {
                          src: require("images/similar_nocontent.png"),
                          alt: "",
                        },
                      }),
                      _c("span", [
                        _vm._v("未上传试题，无法显示题目，可继续设置类题"),
                      ]),
                    ]),
              ]
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "similar-area" }, [
      _c("div", { staticClass: "title" }, [
        _vm._v(" 编辑类题内容 "),
        _c("span", { staticClass: "title-more" }, [
          _vm._v(" (可编辑 "),
          _c("span", { staticStyle: { color: "#478EFF" } }, [
            _vm._v("一道或多道"),
          ]),
          _vm._v("原题的类题) "),
        ]),
      ]),
      _c("div", { staticClass: "editor" }, [
        _c("div", { attrs: { id: "editor" } }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }